import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "text-xl font-semibold text-black" }
const _hoisted_5 = { class: "text-sm text-black" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "text-xs text-black" }
const _hoisted_8 = { class: "p-6" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-between items-center mb-6"
}
const _hoisted_10 = { class: "hidden sm:flex items-center gap-4" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "overflow-hidden" }

import { ref, computed, watch } from 'vue'
import { ReusableTable, UnifiedPagination } from '@/components'

interface Props {
  title: string
  subtitle: string
  topLabel: string
  icon: string
  iconColorClass: string
  iconBgClass: string
  headerGradientClass: string
  dotColorClass: string
  columns: any[]
  data: any[]
  loading?: boolean
  pageSizeOptions?: (number | string)[]
  itemLabel?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardTableSection',
  props: {
    title: {},
    subtitle: {},
    topLabel: {},
    icon: {},
    iconColorClass: {},
    iconBgClass: {},
    headerGradientClass: {},
    dotColorClass: {},
    columns: {},
    data: {},
    loading: { type: Boolean },
    pageSizeOptions: {},
    itemLabel: {}
  },
  emits: ["limit-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// État local
const searchQuery = ref('')
const currentPage = ref(1)
const itemsPerPage = ref(props.pageSizeOptions?.[0] || 10)

// Watcher pour émettre le changement de limite (seulement si pagination activée)
watch(itemsPerPage, (newLimit) => {
  if (props.pageSizeOptions && props.pageSizeOptions.length > 0) {
    emit('limit-change', newLimit)
  }
})

// Données filtrées et paginées
const filteredData = computed(() => {
  if (!searchQuery.value) return props.data
  
  return props.data.filter(item => 
    Object.values(item).some(value => 
      String(value).toLowerCase().includes(searchQuery.value.toLowerCase())
    )
  )
})

const startIndex = computed(() => (currentPage.value - 1) * itemsPerPage.value)
const endIndex = computed(() => Math.min(startIndex.value + itemsPerPage.value, filteredData.value.length))
const paginatedData = computed(() => {
  return filteredData.value.slice(startIndex.value, endIndex.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-6 border-b border-gray-200", _ctx.headerGradientClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-2 rounded-lg", _ctx.iconBgClass])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass([[_ctx.icon, _ctx.iconColorClass], "text-lg"])
            }, null, 2)
          ], 2),
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.topLabel), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["w-2 h-2 rounded-full", _ctx.dotColorClass])
          }, null, 2)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.pageSizeOptions && _ctx.pageSizeOptions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-sm text-black" }, "Afficher", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemsPerPage).value = $event)),
                  class: "px-3 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizeOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option,
                      value: option
                    }, _toDisplayString(option), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, itemsPerPage.value]
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm text-black" }, "entrées", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-sm text-black" }, "Recherche:", -1)),
              _createElementVNode("div", _hoisted_14, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-black text-sm" }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "pl-8 pr-4 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-48",
                  placeholder: "Rechercher..."
                }, null, 512), [
                  [
                    _vModelText,
                    searchQuery.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_unref(ReusableTable), {
          columns: props.columns,
          data: paginatedData.value,
          loading: _ctx.loading,
          sortable: "",
          class: "border-0"
        }, null, 8, ["columns", "data", "loading"]),
        (_ctx.pageSizeOptions && _ctx.pageSizeOptions.length > 0 && filteredData.value.length > itemsPerPage.value)
          ? (_openBlock(), _createBlock(_unref(UnifiedPagination), {
              key: 0,
              "total-items": filteredData.value.length,
              "current-page": currentPage.value,
              "items-per-page": itemsPerPage.value,
              variant: "dashboard",
              "item-label": _ctx.itemLabel || 'entrées',
              "show-items-per-page": false,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (currentPage.value = $event)),
              "onUpdate:itemsPerPage": _cache[3] || (_cache[3] = ($event: any) => (itemsPerPage.value = $event))
            }, null, 8, ["total-items", "current-page", "items-per-page", "item-label"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})